import {DEFAULT_FILTER_PRIORITY} from '@github-ui/filter-core'
import {SelectFilterProvider} from '@github-ui/filter-core/providers'
import {OrganizationIcon} from '@primer/octicons-react'
import {singleValueFilterTypes} from './shared-filter-types'

export class StaticOrgFilterProvider extends SelectFilterProvider {
  constructor(organizations: string[]) {
    const options = organizations.map((org, index) => ({
      value: org,
      displayName: org,
      priority: index + 1,
    }))

    super(
      {
        displayName: 'Organization',
        key: 'org',
        priority: DEFAULT_FILTER_PRIORITY,
        icon: OrganizationIcon,
        description: 'Filter by organization',
      },
      options,
      {
        filterTypes: singleValueFilterTypes,
      },
    )
  }
}
